// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1I16J","selects":"Documents_selects__PJ2cp"};